<div
	class="app-layout-wrapper"
	(click)="onWrapperClick()"
	[style.--sidebar-width.px]="sidebarWidth"
	[ngClass]="{
		'app-table-overflow': appContext.HasTableBasedData,
		'app-sidebar-collapsed': sidebarCollapsed && !isMobile(),
		'app-sidebar-hover-open': isDesktopHoverOverlay(),
	}">
	<p-drawer
		[visible]="!isMobile() || mobileMenuActive || isDesktopHoverOverlay()"
		[modal]="isMobile() || isDesktopHoverOverlay()"
		[blockScroll]="false"
		[position]="'left'"
		[dismissible]="isMobile()"
		[showCloseIcon]="false"
		[style]="{
			width: isMobile() ? '260px' : isDesktopHoverOverlay() ? expandedSidebarWidth + 'px' : sidebarWidth + 'px',
			background: isDesktopHoverOverlay() ? 'transparent !important' : null,
			border: isDesktopHoverOverlay() ? 'none !important' : null,
		}"
		(onHide)="closeMobileMenu()"
		appendTo="body">
		<ng-template pTemplate="headless">
			<div
				class="app-sidebar-shell"
				[ngClass]="{
					'w-sidebar': (!sidebarCollapsed && !isMobile()) || isDesktopHoverOverlay(),
					'w-sidebar-collapsed': sidebarCollapsed && !isMobile() && !isDesktopHoverOverlay(),
					'w-[260px]': isMobile(),
				}"
				(click)="onSidebarClick($event)"
				(mouseenter)="onSidebarMouseEnter()"
				(mouseleave)="onSidebarMouseLeave()">
				<app-sidebar />
			</div>
		</ng-template>
	</p-drawer>

	<div #topStack class="app-top-stack" [ngStyle]="getHeaderStyle()">
		<app-system-banner [systemBannerMessages]="systemBannerMessages" />
		<app-header />
	</div>

	<div class="app-layout-main" [style.marginLeft.px]="sidebarWidth" [style.paddingTop.px]="topStackHeight">
		<app-blockable-div #content styleClass="app-layout-content">
			<router-outlet />
		</app-blockable-div>
		<app-footer />
	</div>
	<p-toast #clearAllToast class="p-toast-clear" key="clearAll" preventOpenDuplicates="true">
		<ng-template let-message pTemplate="message">
			<div class="flex w-full">
				<p-button data-test-id="clearAllButton" label="Clear All" variant="text" (onClick)="onClearAll()" severity="contrast" />
			</div>
		</ng-template>
	</p-toast>
	<p-toast #toast data-test-id="toastMessage" class="p-toast-custom" [ngClass]="{ 'p-toast-custom-offset': showClearAllToast }" (onClose)="onMsgClose()" />
	<p-blockui [blocked]="blocked">
		@if (blocked) {
			<p-progressSpinner [ngClass]="{ loader: pageLevelBlock }" strokeWidth="4" />
		}
	</p-blockui>
	<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" />
</div>
